import React, { useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const Modal1 = ({ isOpen, onClose, children }) => {
  const mouseDownTargetRef = useRef(null);

  if (!isOpen) return null;

  const handleMouseDown = (e) => {
    mouseDownTargetRef.current = e.target;
  };

  const handleMouseUp = (e) => {
    const isBackdropTarget = (target) => {
      return (
        target.classList.contains("modal-backdrop") ||
        target.classList.contains("modal-content-wrapper")
      );
    };

    const mouseDownOnBackdrop =
      mouseDownTargetRef.current &&
      isBackdropTarget(mouseDownTargetRef.current);
    const mouseUpOnBackdrop = isBackdropTarget(e.target);

    if (mouseDownOnBackdrop && mouseUpOnBackdrop) {
      e.stopPropagation();
      onClose(e);
    }

    mouseDownTargetRef.current = null;
  };

  const modalContent = (
    <div
      className="modal-backdrop fixed inset-0 flex h-screen w-screen items-center justify-center bg-black bg-opacity-50 cursor-default"
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      style={{
        zIndex: 2147483647, // Maximum z-index value
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <div
        className="modal-content-wrapper items-center flex-row justify-center flex"
        style={{
          overflow: "auto",
          height: "100vh",
          width: "100vw",
          zIndex: 2147483647,
        }}
      >
        {children}
      </div>
    </div>
  );

  // Render modal in a portal attached to document.body
  // This breaks it out of any stacking context
  return createPortal(modalContent, document.body);
};

export default Modal1;
